import { Box, Button, Text } from '@betty/moonlight';
import { memo, useCallback } from 'react';
import { OptedInPromoBottomSheetProps } from './OptedInPromo.types';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  getPromos,
  optIn,
  selectOptInPending,
} from '../../../state/promos/promos.slice';

function OptedInPromo({
  handleCtaAction,
  title,
  promotionId,
  promoType,
  close,
}: OptedInPromoBottomSheetProps) {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectOptInPending(promotionId));

  const handleOnPress = useCallback(async () => {
    const result = await dispatch(optIn(promotionId));

    if (result.meta.requestStatus === 'fulfilled') {
      dispatch(getPromos());
      handleCtaAction();
      close();
    }
  }, [dispatch, promotionId, handleCtaAction, close]);

  return (
    <Box gap="space-200">
      <Text variant="h5" color="darkSurfacePrimary">
        Continue?
      </Text>
      <Text variant="body-m" color="darkSurfacePrimary">
        {promoType === 'Cashback'
          ? `Your progress on "${title}" will be reset. Do you want to continue?`
          : `Are you sure you want this promo? You will be opted out of "${title}".`}
      </Text>
      <Button
        variant="primary"
        locNS="common"
        locKey="continue"
        width="100%"
        marginTop="space-200"
        loading={isLoading}
        onPress={handleOnPress}
      />
    </Box>
  );
}

export default memo(OptedInPromo);
